import { FileCountBadge } from "@/components/folder/FileCountBadge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { smartDate } from "@/lib/date";
import { Folder } from "@/types/types";
import { useParams } from "@tanstack/react-router";
import { FolderIcon } from "../display/display-icon/artifacts";

type SubFoldersProps = {
  folders: Folder[];
};

export const SubFolders: React.FC<SubFoldersProps> = ({ folders }) => {
  const groupSlug = useGroupSlug();
  const kitUuid = useKitUuid();
  const params = useParams({ strict: false }) as Record<
    string,
    string | undefined
  >;
  const folderUuid = params.folderUuid;
  const splatPath = params["_splat"];

  return (
    <Table className="table-fixed">
      <TableHeader>
        <TableRow className="text-muted-foreground font-family-fancy text-xs font-thin tracking-wide">
          <TableHead className="w-8" />
          <TableHead className="w-80">Folders</TableHead>
          <TableHead className="w-25">Modified</TableHead>
          <TableHead className="w-10">Status</TableHead>
          <TableHead className="w-20 text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {folders.map((folder) => (
          <TableRow
            key={folder.uuid}
            link={{
              to: "/w/$groupSlug/k/$kitUuid/knowledge/$folderUuid/$" as const,
              params: {
                groupSlug: groupSlug!,
                kitUuid: kitUuid!,
                folderUuid: folderUuid!,
                _splat: [splatPath, folder.uuid].filter(Boolean).join("/"),
              },
            }}
          >
            <TableCell>
              <FolderIcon />
            </TableCell>
            <TableCell>
              <div className="truncate font-bold">{folder.name}</div>
            </TableCell>
            <TableCell>{smartDate(folder.dateUpdated)}</TableCell>
            <TableCell>
              <FileCountBadge count={folder.files.length} />
            </TableCell>
            <TableCell />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
